<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">

    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <p v-if="memberLoading" role="status" class="mb-4">กำลังโหลดข้อมูลลูกค้า...</p>
    <div v-if="memberError" role="alert" class="mb-4">{{ memberError }} <vs-button @click="loadMember" size="small">ลองอีกครั้ง</vs-button></div>
    <div id="user-data" v-if="user_data && !memberLoading && !memberError">

      <vx-card title="Account" class="mb-base">

        <!-- Avatar -->
        <div class="vx-row">

          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="user_data.pictureUrl" class="rounded w-full" />
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">รหัสสมาชิก</td>
                <td>{{ user_data.code }}</td>
              </tr>
              <tr>
                <td class="font-semibold">ชื่อ-สกุล</td>
                <td>{{ user_data.firstname }} {{ user_data.lastname }}</td>
              </tr>
              <tr>
                <td class="font-semibold">ธนาคาร</td>
                <td>{{ user_data.bank }}</td>
              </tr>
              <tr>
                <td class="font-semibold">เบอร์โทร</td>
                <td>{{ user_data.tel }}</td>
              </tr>
              <tr>
                <td class="font-semibold">เครดิตที่บันทึกล่าสุด</td>
                <td>{{ user_data.credit }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">สถานะสมาชิก</td>
                <td v-if="user_data.status=='Y'">Active</td>
                <td v-else>InActive</td>
              </tr>
              <tr>
                <td class="font-semibold">วันที่สมัคร</td>
                <td>{{ user_data.createdate }}</td>
              </tr>
              <tr>
                <td class="font-semibold">เลขที่บัญชี</td>
                <td>{{ user_data.account_no }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Web</td>
                <td>
                  <vs-chip class="ag-grid-cell-chip"  v-for="(item,index) in user_data.webs" :key="index" :color="chipColor(item.value)" @click="recreateUser(item)">
                    <span>{{(item.key==='lunarbet')?'amb':item.key}}</span>
                  </vs-chip>
                </td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->

        </div>

      </vx-card>
      <vx-card title="ปิด/เปิด โปรโมชั่น" class="mb-base">
        <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full" style="padding-top: 15px;">
                <label class="text-sm">โปรโมชั่น</label>
                <vs-switch v-model="disablepro.promotion" />
            </div>
            <div class="vx-col sm:w-1/2 w-full" style="padding-top: 15px;">
                <label class="text-sm">ฝากต่อเนื่อง</label>
                <vs-switch v-model="disablepro.continue" />
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full" style="padding-top: 15px;">
                <label class="text-sm">แนะนำเพื่อน</label>
                <vs-switch v-model="disablepro.partner" />
            </div>
            <div class="vx-col sm:w-1/2 w-full" style="padding-top: 15px;">
                <label class="text-sm">คืนยอดเล่น</label>
                <vs-switch v-model="disablepro.cashback" />
            </div>
        </div>
        <!-- <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-4 mt-2" type="border" color="success" @click="saveDisablePro()">SAVE</vs-button>
                </div>
            </div>
        </div> -->
        
          <!-- Information - Col 2 -->

      </vx-card>

      <vx-card title="หาลูกค้า" class="mb-base">

        <!-- Avatar -->


          <!-- Information - Col 1 -->
         <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-select v-model="typeofbonus" class="w-full select-large" label="ประเภทการให้โบนัส">
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in withdrawtypeOptions" class="w-full" />
                </vs-select>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-select v-model="typecalculate" class="w-full select-large" label="ส่วนแบ่งคิดจาก">
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in typeOptions" class="w-full" />
                </vs-select>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full" style="padding-top: 15px;">
                    <label class="text-sm">Status</label>
                    <vs-switch v-model="status_friend" />
            </div>
        </div>
        <br>
        <hr>
        <br>
        <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-1">
               <vs-checkbox v-model="level1">ขั้นที่ 1</vs-checkbox>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-1">
               <vs-checkbox v-model="level2">ขั้นที่ 2</vs-checkbox>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-input class="w-full" label="โบนัส (โบนัสจะคิดเป็นเปอร์เซ็นต์เท่านั้น)" v-model="level1_bonus" :disabled="!level1" />
            </div>
             <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-input class="w-full" label="โบนัส (โบนัสจะคิดเป็นเปอร์เซ็นต์เท่านั้น)" v-model="level2_bonus" :disabled="!level2" />
            </div>
            <!-- <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-input class="w-full" label="โบนัสสูงสุดที่ลูกค้าจะได้รับ (0 คือไม่จำกัด)" v-model="level1_maxbonus" :disabled="!level1" />
            </div> -->
        </div>
        <!-- <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-4 mt-2" type="border" color="success" @click="savePartner()">SAVE</vs-button>
                </div>
            </div>
        </div> -->
        
          <!-- Information - Col 2 -->

      </vx-card>

      <!-- Permissions -->
      <vx-card>
        <div class="mt-5">
        <vs-tabs alignment="fixed">
          <vs-tab label="History">
            <div>
                <vs-row>
                  <vs-col vs-type="flex w-full" vs-justify="center" vs-align="center" vs-w="6">
                    <datepicker placeholder="From" v-model="datefrom"></datepicker>
                  </vs-col>
                  <vs-col vs-type="flex w-full" vs-justify="center" vs-align="center" vs-w="6">
                    <datepicker placeholder="To" v-model="dateto"></datepicker>
                  </vs-col>
                </vs-row>
                <div class="block overflow-x-auto">
                  <p v-if="historyLoading" role="status" class="mb-4">กำลังโหลดรายงาน...</p>
                  <div v-if="historyError" role="alert" class="mb-4">{{ historyError }} <vs-button @click="retryHistory" size="small">ลองอีกครั้ง</vs-button></div>
                  <table v-if="!historyLoading && !historyError" class="w-full permissions-table">
                    <tr>
                      <th class="font-semibold text-base text-left px-3 py-2" v-for="heading in ['Created Date','Type' , 'Admin','Bonus' ,'Amount']" :key="heading">{{ heading }}</th>
                    </tr>

                    <tr v-for="(val, name) in history" :key="name" :bgcolor="checkColor(val.type)">
                      <td class="px-3 py-2"><font color="#000" style="font-weight:600">{{ val.createdate }}</font></td>
                      <td class="px-3 py-2"><font color="#000" style="font-weight:600">{{ val.type }} {{(val.bonustype)?`(${(val.bonustype==='cashback')?'คืนยอดเล่น':(val.bonustype==='continuous')?'ฝากต่อเนื่อง':'แนะนำเพื่อน'})`:''}}</font></td>
                      <td class="px-3 py-2"><font color="#000" style="font-weight:600">{{ (val.employee)?val.employee.email:'' }}</font></td>
                      <td class="px-3 py-2" align="right"><font color="#000" style="font-weight:600">{{ val.bonus }}</font>&nbsp;&nbsp;&nbsp;</td>
                      <td class="px-3 py-2" align="right"><font color="#000" style="font-weight:600">{{ val.qty }}</font>&nbsp;&nbsp;&nbsp;</td>
                    </tr>
                    <tr bgcolor="#7977ef">
                      <td class="px-3 py-2" align="center" bgcolor="#cccccc">&nbsp;</td>
                      <td class="px-3 py-2" align="center" bgcolor="#149140"><font color="#FFF">Deposit :: {{ depositTotal.toFixed(2) }}</font></td>
                      <td class="px-3 py-2" align="center" bgcolor="#b20e0e"><font color="#FFF">Withdraw :: {{ withdrawTotal.toFixed(2) }}</font></td>
                      <td class="px-3 py-2" align="right"><font color="#FFF">Total :: {{ totalBonus.toFixed(2) }}</font>&nbsp;&nbsp;&nbsp;</td>
                      <td class="px-3 py-2" align="center"><font color="#FFF">Total :: {{ total.toFixed(2) }}</font>&nbsp;&nbsp;&nbsp;</td>
                    </tr>
                  </table>
                </div>
            </div>
          </vs-tab>


          <vs-tab label="Logs">
            <div>
                <vs-row>
                  <vs-col vs-type="flex w-full" vs-justify="center" vs-align="center" vs-w="6">
                    <datepicker placeholder="From" v-model="datefrom2"></datepicker>
                  </vs-col>
                  <vs-col vs-type="flex w-full" vs-justify="center" vs-align="center" vs-w="6">
                    <datepicker placeholder="To" v-model="dateto2"></datepicker>
                  </vs-col>
                </vs-row>
                <div class="block overflow-x-auto">
                  <p v-if="logsLoading" role="status" class="mb-4">กำลังโหลดรายงาน...</p>
                  <div v-if="logsError" role="alert" class="mb-4">{{ logsError }} <vs-button @click="retryLogs" size="small">ลองอีกครั้ง</vs-button></div>
                  <table v-if="!logsLoading && !logsError" class="w-full permissions-table">
                    <tr>
                      <th class="font-semibold text-base text-left px-3 py-2" v-for="heading in ['Created Date','Web', 'Type' , 'Admin' ,'Amount']" :key="heading">{{ heading }}</th>
                    </tr>

                    <tr v-for="(val, name) in logs" :key="name" :bgcolor="checkColor2(val.type)">
                      <td class="px-3 py-2"><font color="#000" style="font-weight:600">{{ val.createdate }}</font></td>
                      <td class="px-3 py-2"><font color="#000" style="font-weight:600">{{ (val.web==='lunarbet')?'amb':val.web }}</font></td>
                      <td class="px-3 py-2"><font color="#000" style="font-weight:600">{{ val.type }}</font></td>
                      <td class="px-3 py-2"><font color="#000" style="font-weight:600">{{ (val.employee)?val.employee:'' }}</font></td>
                      <td class="px-3 py-2" align="right"><font color="#000" style="font-weight:600">{{ val.credit }}</font>&nbsp;&nbsp;&nbsp;</td>
                    </tr>
                    <!-- <tr bgcolor="#7977ef">
                      <td class="px-3 py-2" align="center" bgcolor="#cccccc">&nbsp;</td>
                      <td class="px-3 py-2" align="center" bgcolor="#149140"><font color="#FFF">Deposit :: {{ depositTotal.toFixed(2) }}</font></td>
                      <td class="px-3 py-2" align="center" bgcolor="#b20e0e"><font color="#FFF">Withdraw :: {{ withdrawTotal.toFixed(2) }}</font></td>
                      <td class="px-3 py-2" align="center"><font color="#FFF">Total :: {{ total.toFixed(2) }}</font>&nbsp;&nbsp;&nbsp;</td>
                    </tr> -->
                  </table>
                </div>
            </div>
          </vs-tab>
        </vs-tabs>
        </div>
        
        
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.push('/management/user')">Back</vs-button>
                </div>
            </div>
        </div>
      </vx-card>
      
    </div>
  </div>
</template>

<script>
import { createRangeLoader } from '@/services/reportRange';
import { createHelpers } from 'vuex-map-fields'
import Datepicker from 'vuejs-datepicker';
import moment from "moment-timezone";
import firebase from '@/services/saleData'
import 'firebase/database'
const axios = require('axios').default;
const { mapFields } = createHelpers({
  getterType: `userManagement/getField`,
  mutationType: `userManagement/updateField`,
});
export default {
  beforeDestroy () { this._memberRequest++; this._historyLoader.stop(); this._logsLoader.stop(); this.$store.dispatch('userManagement/invalidateUsers'); },
  data () {
    return {
      historyLoading: false, historyError: '', logsLoading: false, logsError: '',
      memberLoading: true, memberError: '',
      balance:0,
      user_not_found: false,
      disabled:false,
      userId:'',
      datefrom:'',
      dateto:'',
      datefrom2:'',
      dateto2:'',
      value:[],
      credits:[],
      status_friend:false,
      typeOptions:[
        {text: "ยอดฝาก", value:"ยอดฝาก"},
        {text: "ยอดเสีย", value:"ยอดเสีย"},
      ], 
      withdrawtypeOptions:[
            {text: "รายวัน", value:"รายวัน"},
            {text: "รายสัปดาห์", value:"รายสัปดาห์"},
            {text: "ทุกวันที่ 1 และ 16 ของเดือน", value:"ทุกวันที่ 1 และ 16 ของเดือน"},
            {text: "รายเดือน", value:"รายเดือน"},
      ],
      level1:false,
      level1_bonus:0,
      level1_maxbonus:0,
      level2:false,
      level2_bonus:0,
      level2_maxbonus:0,
      typeofbonus:'',
      typecalculate:'',
      disablepro:{
        promotion:true,
        partner:true,
        continue:true,
        cashback:true,
      }
    }
  },
  watch: {
    datefrom () {
      this.calculate();
    },
    dateto () {
      this.calculate();
    },
    datefrom2 () {
      this.calculate2();
    },
    dateto2 () {
      this.calculate2();
    },
  },
  computed: {
    ...mapFields([
        'status',
    ]),
    total(){
        return this.$store.state.userManagement.total
    },
    totalBonus(){
        return this.$store.state.userManagement.totalBonus
    },
    user_data () {
      if(this.$store.state.userManagement.user && this.$store.state.userManagement.user.partner) this.setPartner(this.$store.state.userManagement.user.partner)
      if(this.$store.state.userManagement.user && this.$store.state.userManagement.user.disablepro) this.setDisablePro(this.$store.state.userManagement.user.disablepro)
        return this.$store.state.userManagement.user
    },
    history () {
        return this.$store.state.userManagement.history
    },
    logs () {
        return this.$store.state.userManagement.logs
    },
    depositTotal() {
      return this.$store.state.userManagement.depositTotal
    },
    withdrawTotal() {
      return this.$store.state.userManagement.withdrawTotal
    },
    sites () {
      return this.$store.state.userManagement.sites
    },
    chipColor () {
      return (value) => {
        if (value) return 'success'
        return 'danger'
      }
    }
  },
  methods: {
    retryHistory () { this._historyLoader.schedule(this.datefrom, this.dateto, true); },
    retryLogs () { this._logsLoader.schedule(this.datefrom2, this.dateto2, true); },
    async loadMember () {
      const request = this._memberRequest = (this._memberRequest || 0) + 1;
      this.memberLoading = true; this.memberError = '';
      try { await this.$store.dispatch('userManagement/fetchUser', this.userId); }
      catch (_) { if (this._memberRequest === request) this.memberError = 'โหลดข้อมูลลูกค้าไม่สำเร็จ กรุณาลองอีกครั้ง'; }
      finally { if (this._memberRequest === request) this.memberLoading = false; }
    },
    setDisablePro(data){
      this.disablepro = {
        promotion:data.promotion,
        partner:data.partner,
        continue:data.continue,
        cashback:data.cashback,
      }
    },
    saveDisablePro(){
      if(this.user_data && this.user_data.key){
          firebase.database().ref(`/users/${this.user_data.key}/disablepro`).update({
            promotion:this.disablepro.promotion,
            partner:this.disablepro.partner,
            continue:this.disablepro.continue,
            cashback:this.disablepro.cashback,
          });
          this.$vs.notify({
            color: 'success',
            title: 'Save Data',
            text: 'successfully'
          })
      }
    },
    setPartner(data){
      this.typecalculate = data.typecalculate;
      this.typeofbonus = data.typeofbonus;
      this.level1 = data.level1;
      this.level1_bonus = data.level1_bonus;
      this.level1_maxbonus = data.level1_maxbonus;
      this.level2 = data.level2;
      this.level2_bonus = data.level2_bonus;
      this.level2_maxbonus = data.level2_maxbonus;
      this.status_friend = data.status_friend;
    },
    savePartner(){
      //console.log(this.user_data);
      if(this.user_data && this.user_data.key){
          firebase.database().ref(`/users/${this.user_data.key}/partner`).update({
            typecalculate:this.typecalculate,
            typeofbonus:this.typeofbonus,
            level1:this.level1,
            level1_bonus:this.level1_bonus,
            level1_maxbonus:this.level1_maxbonus,
            level2:this.level2,
            level2_bonus:this.level2_bonus,
            level2_maxbonus:this.level2_maxbonus,
            status_friend:this.status_friend,
          });
          this.$vs.notify({
            color: 'success',
            title: 'Save Data',
            text: 'successfully'
          })
      }
    },
    checkColor(type){
      if(type === 'ถอน')
        return '#f9d1df'
      else if(type === 'ฝาก')
        return '#d6f9e7'
      else return '#fcedde'
    },
    checkColor2(type){
      if(type === 'removecredit')
        return '#f9d1df'
      else if(type === 'addcredit')
        return '#d6f9e7'
      else return '#fcedde'
    },
    calculate () { if (this._historyLoader) this._historyLoader.schedule(this.datefrom, this.dateto); },
    calculate2 () { if (this._logsLoader) this._logsLoader.schedule(this.datefrom2, this.dateto2); },
    resetPassWord(){
        this.disabled = true;
        if(this.user_data.tel)
            this.$store.dispatch('userManagement/resetPassword',{user:this.user_data,userId:this.userId}).catch(err => { console.error(err) })
        else{
            this.colorAlert = 'danger'
            this.$vs.dialog({
                color:this.colorAlert,
                title: `Alert`,
                text: 'Please require Tel.',
            })
        }
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.user_data.username}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      this.$router.push({name:'app-user-list'})
      this.showDeleteSuccess()

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.user_data.id)
      //   .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    },
    recreateUser (value) {
      this.value = value;
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Confirm create user',
        text: `You are about to create "${this.user_data.firstname} ${this.user_data.lastname} on ${value.key}"`,
        accept: this.confirmRecreateUser,
        acceptText: 'Sure'
      })
    },
    confirmRecreateUser(){
      console.log(this.user_data.key,this.value.key);
      if(this.user_data.key && this.value.key){
        axios({
          method: "get",
          url: "https://api.xxmac.co/api/createuser/"+this.user_data.key+'/'+this.value.key,
        }).then(async response => {
          if (response.data && response.data.status) {
            this.$store.dispatch('userManagement/fetchUser',this.userId).catch(err => { console.error(err) });
          }
        });
      }
    }
  },
  created () {
    this.userId = this.$route.params.userId;
    this._historyLoader = createRangeLoader({
      invalidate: () => this.$store.dispatch('userManagement/invalidateHistory'),
      loading: value => { this.historyLoading = value; }, error: value => { this.historyError = value; },
      load: range => this.$store.dispatch('userManagement/fetchHistory', {userkey: this.userId, startdate: range.start, enddate: range.end})
    });
    this._logsLoader = createRangeLoader({
      invalidate: () => this.$store.dispatch('userManagement/invalidateLogs'),
      loading: value => { this.logsLoading = value; }, error: value => { this.logsError = value; },
      load: range => this.$store.dispatch('userManagement/fetchLogs', {userId: this.user_data.code, startdate: range.start, enddate: range.end})
    });
    this.loadMember();
  },
  components: {
    Datepicker
  },
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}
#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 200px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>
